import { render, staticRenderFns } from "./ListTransaction.vue?vue&type=template&id=20c8414e"
import script from "./ListTransaction.vue?vue&type=script&lang=js"
export * from "./ListTransaction.vue?vue&type=script&lang=js"
import style0 from "./ListTransaction.vue?vue&type=style&index=0&id=20c8414e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports